import React, {Component} from 'react';
import {NavBar} from 'antd-mobile';
import './style.less';

export default class InvoiceApply extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    
    componentDidMount() {

    }

    render() {
        return (
            <div className="invoiceApply">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconmorenfanhui" onClick={() => this.props.history.goBack()}></i>}
                >帮助中心</NavBar>
                <div className="contentBox">
                    <div className="title">关于发票申请</div>
                    <div className="first">
                        <div>1、电子发票免费开具，纸质发票收取10元邮寄费用。特殊要求请在发票申请备注内填写说明。</div>
                        <div>2、若是乘客自身原因填错发票信息，不得重开发票。</div>
                        <div>3、三个月以内的订单可以开具发票，超出时间不允开具。</div>
                        <div>4、行程结束后才可申请开具发票。</div>
                        <div>5、电子发票的开具在一个工作日内，纸质发票的开具邮寄在7个工作日内。</div>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/container/Member/HelpCenter/InvoiceApply/index.js